import moment from "moment";

export const formatWithOffset = (date) => {
  return moment(date)
    .subtract(5, 'hours')
    .subtract(30, 'minutes')
    .format('YYYY-MM-DD HH:mm:ss');
};


export const formatWithoutOffset = (date) => {
  return moment(date)
    // .subtract(5, 'hours')
    // .subtract(30, 'minutes')
    .format('YYYY-MM-DD HH:mm:ss');
};
